import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import type { RegisterCredentials } from '@practium/features/auth';
import type { ActivePolicyVersion } from '../policies/useActivePolicies';

interface RegisterPayload extends RegisterCredentials {
	activePolicies: ActivePolicyVersion[];
}

export const useRegister = () => {
	return useMutation({
		mutationFn: async ({ activePolicies, ...credentials }: RegisterPayload) => {
			const consents = credentials.acceptedTerms
				? activePolicies.map((policy) => ({
						policyVersionId: policy._id,
						accepted: true,
					}))
				: [];

			await api
				.post('/user/register', {
					name: credentials.name,
					surName: credentials.surName || undefined,
					email: credentials.email,
					password: credentials.password,
					consents,
				})
				.catch((error) => {
					throw toApiError(error, 'Erro ao criar conta');
				});
		},
		onError: (error) => {
			console.error('Erro ao registrar:', getApiErrorMessage(error, 'Erro ao criar conta'));
		},
	});
};
